import { useLocalSearchParams, useRouter } from 'expo-router';
import * as React from 'react';
import { View } from 'react-native';
import Toast from 'react-native-toast-message';
import { useStyles } from 'react-native-unistyles';

import ConfirmOtp from '@/components/confirm-otp';

export default function ConfirmPhone() {
  const { theme } = useStyles();
  const router = useRouter();
  const item = useLocalSearchParams();

  return (
    <View style={{ flex: 1, backgroundColor: theme.colors.background_2 }}>
      <ConfirmOtp
        onBack={() => {
          router.back();
        }}
        onDone={() => {
          Toast.show({
            text1: 'Phone number updated successfully',
            type: 'success',
          });
          router.navigate('/account/profile');
        }}
        phone={item.phone as string}
      />
    </View>
  );
}
